<template>
  <b-card title="ภาพรวมการเงินของฉัน :">
    <app-timeline>
      <!-- 12 INVOICES HAVE BEEN PAID -->
      <app-timeline-item>
        <div
          class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
        >
          <h6>รายรับทั้งหมด</h6>
          <small>{{ userData.finance.totalRevenue }} บาท</small>
        </div>
        <!-- <p>Invoices have been paid to the company.</p>
            <p class="mb-0">
              <b-img
                :src="require('@/assets/images/icons/pdf.png')"
                height="auto"
                width="20"
                class="mr-1"
              />
              <span class="align-bottom">invoice.pdf</span>
            </p> -->
      </app-timeline-item>
      <app-timeline-item variant="warning">
        <div
          class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
        >
          <h6>การถอนเงินทั้งหมด</h6>
          <small> {{ userData.finance.withdrawal }} บาท</small>
        </div>
      </app-timeline-item>
      <app-timeline-item variant="info">
        <div
          class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
        >
          <h6>การคืนเงินทั้งหมด</h6>
          <small> {{ userData.finance.refund }} บาท</small>
        </div>
      </app-timeline-item>
    </app-timeline>
  </b-card>
</template>

<script>
import { BCard, BImg, BMedia, BAvatar } from "bootstrap-vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

export default {
  components: {
    BCard,
    BImg,
    BMedia,
    BAvatar,
    AppTimeline,
    AppTimelineItem,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style></style>
